// Czech translations
export const cs = {
  // Common
  common: {
    home: 'Domů',
    settings: 'Nastavení',
    language: 'Jazyk',
    loading: 'Načítání...',
    save: 'Uložit',
    cancel: 'Zrušit',
    confirm: 'Potvrdit',
    close: 'Zavřít',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Nastavení',
    home: 'Domů',
    howToPlay: 'Jak hrát',
    pieceRules: 'Pravidla figurek',
    language: 'Jazyk',
    manageSubscription: 'Spravovat předplatné',
    gameHistory: 'Historie her',
    analytics: 'Analytika',
    premiumAccount: 'Premium účet',
    chatEnabled: 'Chat: Zapnuto',
    chatDisabled: 'Chat: Vypnuto',
  },

  // Piece Rules
  pieceRules: {
    title: 'Pravidla figurek',
    description: 'Naučte se pohyby figurek',
    selectPiece: 'Vybrat figurku',
    selectedLabel: 'Vybráno:',
    statusLabel: 'Stav:',
    statusReady: 'Připraveno',
    statusViewing: 'Prohlížení',
    movement: 'Pohyb',
    regularMovement: 'Běžný pohyb',
    ability: 'Schopnost',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Pohyb',
    savage: 'Divoký',
    birdtype: 'Typ ptáka',
    birdType: 'Typ ptáka',
    wallBlock: 'Blok zdi',
    moveblocks: 'Bloky pohybu',
    wallclimb: 'Lezení po zdi',
    lilypad: 'Leknín',
    poisonous: 'Jedovatý',
    meadow: 'Louka',
    parasiticfungi: 'Parazitická houba',
    zombification: 'Zombifikace',
    fungi: 'Houba',
    traverse: 'Procházení',
    capture: 'Braní',
    faint: 'Mdloba',
    leap: 'Skok',
    swing: 'Houpání',
    consume: 'Konzumace',
    gamble: 'Hazard',
    entangle: 'Zamotání',
    ink: 'Inkoust',
    rotate: 'Rotace',
    backstep: 'Krok zpět',
    trample: 'Šlapání',
    charge: 'Náboj',
    lane: 'Pruh',
    snakestrike: 'Hadí úder',
    shedskin: 'Svlékání kůže',
    house: 'Dům',
    plant: 'Typ rostliny',
    planttype: 'Typ rostliny',
    capturehost: 'Braní hostitele',
    contagion: 'Nákaza',
    lonewolf: 'Osamělý vlk',
    hop: 'Poskakování',
    decay: 'Rozklad',
    slide: 'Klouzání',
    block: 'Blok',
    poison: 'Jed',
    infection: 'Infekce',
    howl: 'Vytí',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Medvěd se může pohybovat o jedno pole libovolným směrem, jako král v šachu',
    bearMovementPost: 'Je blokován pouze přátelskými figurkami (kromě stromů, medvědi mohou lézt na stromy!)',
    bearSavage: 'Medvěd může překonat obranné schopnosti jako blok nosorožce',
    bearSavagePost: 'Použitím Divoký může medvěd vzít jakoukoli figurku z jakéhokoli směru, což přidává smrtelnost',

    // Crane
    craneMovement: 'Jeřáb se může pohybovat o 1 nebo 2 pole v jakékoli přímce',
    craneMovementPost: 'Jeřáb může dokonce přeletět přes jiné figurky!',
    craneBirdType: 'Figurky typu ptáka nemohou brát velké nebo dravé figurky',
    craneBirdTypePost: 'To zahrnuje strom, nosorožce, medvěda a vlka',

    // Frog
    frogMovement: 'Žába skáče o 2 pole diagonálně',
    frogMovementPost: 'Nemůže skočit jen o jedno',
    frogWallBlock: 'Pokud je běžná 2polní cesta žáby blokována zdí nebo jinou figurkou, nemůže brát',
    frogWallBlockPost: 'Její běžný pohyb je zkrácen na 1 pole diagonálně',
    frogWallClimb: 'Když je žába na okraji desky (sloupec A nebo E), může se pohybovat o jedno nahoru nebo dolů',
    frogWallClimbPost: 'Pokud není blokována přátelskou figurkou nebo nosorožcem před žábou',
    frogLilypad: 'Pokud se žába ještě nepohla ve hře, může skočit na kteroukoli z prvních 3 řad jako mocná obranná schopnost',
    frogLilypadPost: 'Může vzít jakoukoli běžnou figurku pomocí skoku leknínu, kromě nosorožce na vyšší řadě než je sama',
    frogPoisonous: 'Když jakékoli zvíře vezme figurku žáby, stanete se otráveným!',
    frogPoisonousPost: 'Otrávená figurka přeskočí svůj další dostupný tah před zotavením',

    // Fungi
    fungiMovement: 'Houba se může pohybovat o jedno pole libovolným směrem',
    fungiMovementPost: 'Je blokována pouze spojeneckými figurkami',
    fungiMeadow: 'Houba snižuje pohybovou schopnost nepřátelské figurky stromu',
    fungiMeadowPost: 'Nepřátelská figurka stromu se nemůže pohybovat do 1 pole od figurky houby',
    fungiParasitic: 'Houba může znehybnit nepřátelskou figurku stromu',
    fungiParasiticPost: 'Pokud je houba do 1 pole od nepřátelského stromu, nemůže se pohybovat, dokud se houba neodstěhuje nebo není vzata',
    fungiZombification: 'Houba může zombifikovat jakoukoli nepřátelskou zvířecí figurku, která ji vezme, což umožňuje kontrolu nad nepřátelským zvířetem na jeden tah',
    fungiZombificationPost: 'Zombifikovaná figurka je také považována za figurku houby pro ten tah, i když byla houba vaším králem, hra nekončí až po tom tahu',
    fungiFungi: 'Houba',
    fungiFungiPost: 'Jako jed, zamotání a virová infekce, ale ne zombifikace, protože může zombifikovat ostatní!',

    // Goat
    goatMovement: 'Koza se může pohybovat o jedno pole libovolným směrem',
    goatMovementPost: 'Koza se pohybuje pomalu, ale má mocné schopnosti',
    goatTraverse: 'Koza může procházet přes jakékoli jiné propojené figurky a vytvářet tak obrovský potenciál pohybu',
    goatTraversePost: 'Koza nemůže procházet přes omdlelé kozy nebo malé figurky jako virus',
    goatCapture: 'Koza nemůže brát žádné predátory',
    goatCapturePost: 'Jako medvěd nebo vlk',
    goatFaint: 'Koza může omdlít, aby se vyhnula braní, kromě velkých figurek jako strom a nosorožec',
    goatFaintPost: 'Během mdloby mohou protivníci "stát" na omdlelé koze, aby zastavili její pohyb',

    // Monkey
    monkeyMovement: 'Opice se může pohybovat o jedno pole libovolným směrem',
    monkeyMovementPost: 'Bez jiných figurek k použití má opice omezený pohyb',
    monkeyLeap: 'Opice může jako v dámě přeskakovat přes jiné figurky v přímce pro obrovský potenciál pohybu',
    monkeyLeapPost: 'Ale pokud přeskakuje přes nepřátelskou figurku, musí opice hodit kostkou, aby přežila skok, šance 1/6 na braní za každého nepřítele, přes kterého přeskočí!',
    monkeySwing: 'Pokud opice použije skok přes strom, opice získá bonusový tah',
    monkeySwingPost: 'Použití houpání stromem vytváří mocné synergické kombo mezi opicí a figurkou stromu',
    monkeyConsume: 'Opice může konzumovat houbu pro bonusový tah',
    monkeyConsumePost: 'Což vede k ničivým kombinacím v kombinaci s jinými bonusovými tahy',
    monkeyGamble: 'Kromě hození kostkou pro přeskočení nepřátel musí opice riskovat, aby vzala medvěda',
    monkeyGamblePost: 'Opice musí hodit 5 nebo 6 na 6stěnné kostce, aby vzala medvěda, nebo je vzata sama',

    // Octopus
    octopusMovement: 'Chobotnice se pohybuje o jedno pole libovolným směrem',
    octopusCapture: 'Chobotnice může brát pouze ortogonálně',
    octopusCapturePost: 'Chobotnice může brát nebo zamotat figurky složitými způsoby, takže vždy kontrolujte červená braní a fialová zamotání!',
    octopusEntangle: 'Chobotnice může zamotat sousední nepřátelské figurky a znehybnit je, může dokonce přejít o pole a zamotat nepřátele!',
    octopusEntanglePost: 'Zamotané figurky se nemohou pohybovat, dokud se chobotnice neodstěhuje nebo není vzata',
    octopusInk: 'Chobotnice může použít inkoust k úniku z nebezpečných situací a vytvořit až 3 stíny',
    octopusInkPost: 'Zmást nepřítele a umožnit zajímavé návnadové a vyhýbavé hry',

    // Penguin
    penguinMovement: 'Tučňák klouže v přímce ve svém nastaveném směru, dokud zeď nebo figurka nezablokuje jeho pohyb',
    penguinMovementPost: 'Po pohybu může tučňák ve stejném tahu také nastavit svůj konečný směr',
    penguinRotate: 'Na začátku zápasu je tučňák obrácen dolů a musí se otočit, než může klouzat, také známý jako spící',
    penguinRotatePost: 'Tučňák v jakékoli poloze může zvolit otočení místo pohybu',
    penguinBirdType: 'Tučňák má omezené schopnosti braní, stejně jako jeřáb nemůže brát velké nebo dravé figurky jako strom, nosorožec, medvěd nebo vlk',
    penguinBirdTypePost: 'Po braní se může tučňák otočit směrem k jakémukoli směru pro strategické umístění',

    // Rhino
    rhinoMovement: 'Nosorožec se pohybuje dva pole pouze dopředu',
    rhinoMovementPost: 'Nemůže se pohybovat jen o 1 pole',
    rhinoBackStep: 'Nosorožec se může pohybovat zpět-vlevo nebo zpět-vpravo',
    rhinoCharge: 'Nosorožec jednou za hru může cestovat o jedno pole navíc dopředu pomocí své schopnosti náboje',
    rhinoChargePost: 'Což vede k ničivému pohybu a braní potenciálu',
    rhinoTrample: 'Nosorožec bere všechny figurky na své cestě šlapáním',
    rhinoTramplePost: 'Včetně omdlelé figurky kozy',
    rhinoLane: 'Nosorožec může vyměnit místa s jinou spojeneckou figurkou, což umožňuje strategickou hru pruhů',
    rhinoLanePost: 'Ale pouze pokud se nosorožec a spojenecká figurka oba nepohli',

    // Snake
    snakeMovement: 'Had se může pohybovat o 2 pole v jakékoli přímce',
    snakeMovementPost: 'Had se pohybuje přesně o 2 pole, pokud není blokován zdí nebo přátelskou figurkou',
    snakeMoveBlocks: 'Když je blokován zdí nebo figurkou, kterou nemůže vzít, pohyb hada je zkrácen na 1 pole',
    snakeMoveBlocksPost: 'Může se stále pohybovat dva pole, i když je mezi tím figurka',
    snakeStrike: 'Had může udeřit o 3 pole dopředu, pokud je tam nepřátelské zvíře',
    snakeStrikePost: 'Pokud žádné mezilehlé figurky neblokují jeho cestu',
    snakeShedskin: 'Jednou za hru může had svléknout kůži a vrátit se do první řady, pokud je pole volné',
    snakeShedskinPost: 'Toto znovuzrození dává hadovi extra život každou hru',

    // Tree
    treeMovement: 'Strom se může pohybovat o jedno pole dopředu nebo na jakékoli pole ve své řadě ze strany na stranu',
    treeMovementPost: 'Pokud jeho cesta není blokována',
    treeHouse: 'Strom může ubytovat jiné figurky a chránit je před nepřáteli, kteří nemohou lézt na stromy. Možná figurky mohou lézt jako medvěd, jeřáb, žába, houba, koza, opice, chobotnice a had',
    treeHousePost: 'Když figurka, která může lézt na strom, útočí, vezme pouze ubytovanou figurku a chrání strom',
    treeTrample: 'Strom jako nosorožec bere všechny figurky na poli, když se pohybuje',
    treeTramplePost: 'To zahrnuje omdlelou kozu',
    treePlant: 'Strom je rostlina, ne zvíře, takže je imunní vůči několika efektům',
    treePlantPost: 'Jako jed, zombifikace, zamotání a virová infekce!',

    // Virus
    virusMovement: 'Virus se může pohybovat pouze na pole obsazená zvířaty, která jsou vzdálená dva pole',
    virusMoveBlocks: 'Virus se může pohybovat pouze o jedno pole, pokud je vedle zdi',
    virusCaptureHost: 'Když virus přistane na (v) jakékoli zvířecí figurce, pouze je nakazí, mohou stále pokračovat v běžné hře, když jsou nakaženi',
    virusCaptureHostPost: 'Virus vezme figurku pouze když opustí nakaženého hostitele',
    virusContagion: 'Virus se může rychle šířit nakažením více hostitelů v jednom tahu',
    virusContagionPost: 'Nákaza umožňuje viru provést tolik legálních tahů, kolik chce každý tah',

    // Wolf
    wolfMovement: 'Vlk se může pohybovat do tvaru L, jako jezdec v šachu',
    wolfMovementPost: 'Není blokován žádnými jinými figurkami',
    wolfLoneWolf: 'Vlk',
    wolfLoneWolfPost: 'Vlk se také považuje za osamělého, když má stále omdlelou kozu nebo virového spojence',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Táhněte pro prozkoumání • Štípněte pro přiblížení',
    dragToExploreDesktop: '🖱️ Táhněte pro prozkoumání • Scrollujte pro přiblížení',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Zpět',
    next: 'Další',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'PÍSKOVIŠTĚ',
    description: 'Experimentujte a cvičte',
    mode: 'Režim:',
    modeValue: 'Pískoviště',
    status: 'Stav:',
    statusReady: 'Připraveno',
    clearBoard: 'Vymazat desku',
  },

  // Multiplayer
  multiplayer: {
    title: 'VÍCE HRÁČŮ',
    description: 'Najděte svůj zápas a soutěžte!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Umístění zápasů',
    matchProgress: 'Postup zápasu',
    gamesCompleted: '{games} / 10 dokončených her',
    estimatedFinalRating: 'Odhadované konečné hodnocení',
    startingRating: 'Počáteční hodnocení',
    matchesRemaining: 'Zbývá {matches} zápasů',
    findPlacementMatch: 'Najít umístění zápasu',

    // Matchmaking modes
    findMatch: 'Najít zápas',
    competitive: 'Soutěžní',
    competitiveDesc: 'Najděte protivníky blízko vašeho hodnocení',
    quick: 'Rychlý',
    quickDesc: 'Rychle najděte soutěžní zápasy',
    casual: 'Neformální',
    casualDesc: 'Bez hodnocení - hrajte pro zábavu!',
    placement: 'Umístění',
    placementDesc: 'Dokončete 10 zápasů pro hodnocení',
    startSearch: 'Spustit hledání',

    // Searching
    searching: 'Hledání...',
    mode: 'Režim:',
    inQueue: 'Ve frontě:',
    players: 'hráč',
    playersPlural: 'hráči',
    cancelSearch: 'Zrušit hledání',

    // Game info
    status: 'Stav:',
    ready: 'Připraveno',
    selectingKing: 'Výběr krále',
    placingPieces: 'Umísťování figurek',
    playing: 'Hraní',
    gameType: 'Typ hry:',
    opponent: 'Protivník:',
    opponentElo: 'ELO protivníka:',
    unranked: 'Bez hodnocení',

    // Piece placement
    dragPieces: 'Táhněte figurky na desku',
    lightPieces: 'Světlé figurky (Vy)',
    darkPieces: 'Tmavé figurky (Vy)',

    // Waiting states
    waitingForOpponent: 'Čekání na protivníka...',
    waitingForKing: 'Čekání na výběr krále protivníkem...',

    // Warnings
    invalidPlacement: 'Neplatné umístění',
    lightTurn: 'Je na tahu světlý hráč!',
    darkTurn: 'Je na tahu tmavý hráč!',
    onlyLightPieces: 'Můžete umístit pouze světlé figurky!',
    onlyDarkPieces: 'Můžete umístit pouze tmavé figurky!',
    mustPlaceOnRow: 'Figurky {color} musí být umístěny na řadě {row}!',

    // Chat
    chat: 'Chat',
    typeMessage: 'Napište zprávu...',
    send: 'Odeslat',
  },

  // Main Page
  mainPage: {
    title: 'ZVÍŘECÍ ŠACHY',
    subtitle: 'Hra pro lidi',
    playersOnline: 'Aktuální hráči online',
    placement: 'Umístění',
    placementProgress: 'Umístění',
    challengeAI: 'Vyzvěte AI',
    multiplayer: 'Více hráčů',
    sandbox: 'Pískoviště',
    tutorials: 'Návody',
    shop: 'Obchod',
    collection: 'Kolekce',
    history: 'Historie',
    analytics: 'Analytika',
    courses: 'Kurzy',
    upgradeAccount: 'Upgradovat účet',
    signIn: 'Přihlásit se',
    playAsGuest: 'Hrát jako host',
    welcomeBack: 'Vítejte zpět! Obvykle hrajete jako',

    // Learn the Pieces section
    learnThePieces: 'Naučte se figurky',

    // Learn the Rules section
    learnTheRules: 'Naučte se pravidla',
    premiseTitle: 'Předpoklad',
    premiseText: 'Zodiac je alternativa šachů se SKRYTÝM králem z rostrů 13 figurek, vyberte unikátní rostru a pak blufujte svého protivníka, abyste je porazili na desce 5 x 8',
    selectionTitle: 'Výběr',
    selectionText: 'Pro začátek hry tajně vyberte svého krále, pak umístěte svých 5 figurek střídavě se svým protivníkem, abyste vytvořili jeden z více než 500 miliard počátečních stavů.',
    objectiveTitle: 'Cíl',
    objectiveText: 'Buď přečtěte svého protivníka, abyste VZALI jeho tajného krále, nebo ZÁVOĎTE svého krále přes desku, abyste zajistili vítězství!',
    competeTitle: 'Soutěžte',
    competeText: 'Testujte své dovednosti na žebříčku, vytvářejte nové osobní techniky a strategie, postupujte výš, abyste se postavili těm nejlepším!',
    fullRulesButton: 'Pro úplná oficiální pravidla klikněte zde',

    // FAQ section
    faqTitle: 'Často kladené otázky',
    faqQuestion1: 'Jaký je nápad za Zodiac šachy?',
    faqAnswer1: 'Zodiac šachy byly zpočátku inspirovány slovy Bobby Fischera o jeho inspiraci vytvořit Chess960, chtěli jsme rozšířit myšlenku boje proti mechanickému memorování a oslavovat lidskou intuici v nepředstavitelné hloubce!',
    faqQuestion2: 'Proč potřebujeme alternativu šachů',
    faqAnswer2: 'Nepotřebujeme! Zodiac nechce lidi odvést od hraní šachů! Je to jiná možnost se svými vlastními silnými a slabými stránkami, doufáme, že si s tím užijete zábavu a pomůžete nám přizpůsobit tuto hru, aby oživila novou hru',
    faqQuestion3: 'Jak vyhrát v Zodiac šachách?',
    faqAnswer3: 'Existují tři způsoby, jak vyhrát: vzít skrytou královskou figurku protivníka, závodit svého vlastního krále na druhou stranu desky, nebo v zápase s časovou kontrolou nechat vypršet čas protivníka',
    faqQuestion4: 'Je to FAQ?',
    faqAnswer4: 'Ano, můžete se podívat na kteroukoli z uvedených otázek v FAQ a pokud chcete trochu více podrobností, můžete kliknout na otázky a pak si přečíst následující podrobnosti, jako jsou tyto podrobnosti, které právě čtete',
    faqQuestion5: 'Jak dlouho trvá typická hra?',
    faqAnswer5: 'Každá hra se značně liší! Některé hry jsou hotové za 2 tahy a některé mohou trvat 30 minut, obvykle zjišťujeme, že jsou v rozmezí 5-15 minut!',
    faqQuestion6: 'Co se stane, když nikdo nemůže provést legální tah?',
    faqAnswer6: 'Pokud hráč nemůže provést žádný legální tah (pat), hra končí remízou. Hra může také skončit remízou opakováním (stejný stav desky 3krát) nebo vzájemnou dohodou mezi hráči!',

    // About section
    aboutButton: 'O nás',
    privacyPolicy: 'Zásady ochrany osobních údajů',
    developerInterface: 'Rozhraní vývojáře',
  },

  // About Modal
  about: {
    title: 'O Zodiacu',
    paragraph1: 'Zodiac je šachům podobná desková hra kombinující prvky výběru figurek z her jako LoL a DotA, s blufovacími mechanikami z pokeru nebo sociálních dedukčních her.',
    paragraph2: 'Rané verze hry byly vytvořeny v roce 2014 pod názvem Shadow Chess. V roce 2018 byla přepracována na to, co vidíte dnes, zahrnující rostru zábavných figurek s vyváženými, ale unikátními pohybovými vzory a schopnostmi.',
    paragraph3: 'Naše vize je zaznamenat všechna uživatelská data o hře, abychom mohli pokračovat ve vývoji hry ve snaze udržet hru osvěžující a povzbuzovat nové hry.',
    paragraph4: 'S gigantickým vyhledávacím prostorem Zodiacu, skrytými informacemi a zahajovacími pozicemi desky doufáme, že odvrátíme dominanci AI a udržíme zodiac jako hru pro lidi!',
  },

  // Privacy Policy
  privacy: {
    title: 'Zásady ochrany osobních údajů',
    lastUpdated: 'Naposledy aktualizováno',

    introduction: {
      title: 'Úvod',
      p1: 'Vítejte v Zodiac Chess ("my", "naše" nebo "nás"). Jsme odhodláni chránit vaše soukromí a zajistit, abyste měli bezpečný a příjemný herní zážitek. Tyto zásady ochrany osobních údajů vysvětlují, jak shromažďujeme, používáme, zveřejňujeme a chráníme vaše informace, když používáte naši webovou stránku a hru.',
      p2: 'Používáním Zodiac Chess souhlasíte se shromažďováním a používáním informací v souladu s těmito zásadami. Pokud nesouhlasíte s našimi zásadami a postupy, nepoužívejte prosím naši službu.',
      contact: 'Kontaktujte nás:',
    },

    infoCollect: {
      title: 'Informace, které shromažďujeme',
      accountInfo: {
        title: '1. Informace o účtu',
        item1: 'E-mailová adresa: Vyžadováno pro vytvoření účtu a komunikaci',
        item2: 'Uživatelské jméno: Vaše zvolené zobrazované jméno',
        item3: 'Heslo: Šifrované a bezpečně uložené',
      },
      gameData: {
        title: '2. Herní data',
        item1: 'Herní statistiky: Výhry, prohry, ELO hodnocení, postup umístění zápasů',
        item2: 'Data o hře: Výběry figurek, provedené tahy, použité strategie',
        item3: 'Historie zápasů: Záznamy odehraných her, čelených protivníků',
        item4: 'Nákupy ve hře: Kosmetické předměty a stav prémiového členství',
      },
      technicalData: {
        title: '3. Technická data',
        item1: 'Informace o zařízení: Typ prohlížeče, operační systém',
        item2: 'Data o použití: Navštívené stránky, strávený čas, použité funkce',
        item3: 'Místní úložiště: Jazykové preference, nastavení uživatelského rozhraní, dočasný stav hry',
      },
    },

    children: {
      title: 'Soukromí dětí (dodržování COPPA)',
      p1: 'Zodiac Chess je navržen tak, aby byl vhodný pro rodiny a vhodný pro hráče všech věkových kategorií, včetně dětí. Zvláštní péči věnujeme dodržování zákona o ochraně soukromí dětí online (COPPA).',
      p2: 'Pro uživatele mladší 13 let: Doporučujeme, aby děti používaly náš režim hry pro hosty, který nevyžaduje vytvoření účtu ani shromažďování dat. Hostující účty nemají přístup k funkcím textového chatu, což zajišťuje, že děti nejsou vystaveny komunikaci se širším internetem. Pokud dítě vytvoří účet, vyžadujeme souhlas rodičů před shromažďováním jakýchkoli osobních údajů.',
      p3: 'Vědomě neshromažďujeme, nepoužíváme ani nesdílíme osobní údaje od dětí mladších 13 let bez ověřeného souhlasu rodičů.',
      p4: 'Bezpečnost chatu: Textový chat je automaticky vypnut pro všechny hostující/dočasné účty. Držitelé standardních účtů mají možnost kdykoli zakázat funkci chatu v nastavení účtu.',
      parentalRights: 'Rodiče mají právo:',
      right1: 'Zkontrolovat osobní údaje svého dítěte',
      right2: 'Požádat o vymazání dat svého dítěte',
      right3: 'Odmítnout další shromažďování nebo použití informací jejich dítěte',
      contactUs: 'Pro uplatnění těchto práv nebo pokud se domníváte, že vaše dítě nám poskytlo osobní údaje, okamžitě nás kontaktujte na contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Jak používáme vaše informace',
      item1: 'Poskytování a zlepšování našich herních služeb',
      item2: 'Spárování s vhodnými protivníky na základě úrovně dovedností',
      item3: 'Sledování vašeho postupu, statistik a úspěchů',
      item4: 'Zpracování plateb za prémiová členství a kosmetické předměty',
      item5: 'Odesílání důležitých oznámení o službách a aktualizací',
      item6: 'Analýza herních dat pro zlepšení rovnováhy hry a funkcí',
    },

    thirdParty: {
      title: 'Služby třetích stran',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Používáme Firebase pro ověřování, ukládání databáze a funkce pro více hráčů. Firebase může shromažďovat určitá data, jak je popsáno v jejich zásadách ochrany osobních údajů.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Používáme Stripe ke zpracování plateb za prémiová členství a nákupy v aplikaci. Stripe zpracovává všechny informace o platební kartě - nikdy nevidíme ani neukládáme vaše úplné platební údaje.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Naše webová stránka je hostována na Netlify, která může shromažďovat standardní data webhostingu, jako jsou IP adresy a přístupové logy.',
      },
      adsense: {
        title: 'Google AdSense (budoucnost)',
        description: 'Můžeme zobrazovat reklamy prostřednictvím Google AdSense. Tyto reklamy mohou používat cookies pro personalizaci. Pro obsah zaměřený na děti budeme zobrazovat pouze nepersonalizované reklamy v souladu s COPPA.',
      },
      viewPolicy: 'Zobrazit jejich zásady ochrany osobních údajů',
    },

    cookies: {
      title: 'Cookies a místní úložiště',
      description: 'Používáme místní úložiště prohlížeče (podobné cookies) ke zlepšení vaší zkušenosti:',
      item1: 'Jazyková preference: Zapamatovat si váš vybraný jazyk',
      item2: 'Relace účtu: Udržovat vás přihlášené (funguje s Firebase)',
      item3: 'Nastavení hry: Zapamatovat si vaše preference uživatelského rozhraní a nastavení pískoviště',
      item4: 'Reklamní cookies: Pokud souhlasíte, služby reklamy třetích stran mohou používat cookies pro personalizaci reklam',
    },

    security: {
      title: 'Zabezpečení dat',
      p1: 'Implementujeme vhodná bezpečnostní opatření na ochranu vašich informací:',
      item1: 'Šifrování hesel: Všechna hesla jsou šifrována pomocí průmyslových standardních metod',
      item2: 'Zabezpečená spojení: HTTPS šifrování pro veškerý přenos dat',
      item3: 'Bezpečnostní pravidla Firebase: Přísné kontroly přístupu k databázi',
      p2: 'Žádná metoda přenosu přes internet však není 100% bezpečná. Zatímco se snažíme chránit vaše data, nemůžeme zaručit absolutní bezpečnost.',
    },

    retention: {
      title: 'Uchovávání dat',
      p1: 'Vaše data uchovávame následovně:',
      item1: 'Aktivní účty: Data jsou uchovávána, dokud je váš účet aktivní',
      item2: 'Neaktivní účty: Pokud je váš účet neaktivní po dobu 10 let, můžeme vaše data vymazat',
    },

    rights: {
      title: 'Vaše práva na soukromí',
      description: 'V závislosti na vaší poloze můžete mít následující práva:',
      access: {
        title: 'Přístup:',
        description: 'Požádat o kopii vašich osobních údajů',
      },
      correction: {
        title: 'Oprava:',
        description: 'Požádat o opravy vašich dat',
      },
      deletion: {
        title: 'Vymazání:',
        description: 'Požádat o vymazání vašeho účtu a dat',
      },
      portability: {
        title: 'Přenositelnost dat:',
        description: 'Požádat o vaše data v přenosném formátu',
      },
      optOut: {
        title: 'Odhlášení:',
        description: 'Odhlásit se z marketingové komunikace',
      },
      contact: 'Pro uplatnění některého z těchto práv nás prosím kontaktujte na contact@zodiac-chess.com',
    },

    international: {
      title: 'Mezinárodní uživatelé',
      p1: 'Zodiac Chess je provozován z Nového Zélandu. Pokud přistupujete k naší službě mimo Nový Zéland, uvědomte si prosím, že vaše informace mohou být přeneseny, ukládány a zpracovávány na Novém Zélandu a v jiných zemích, kde působí naši poskytovatelé služeb.',
      p2: 'Používáním naší služby souhlasíte s přenosem vašich informací do zemí mimo vaši zemi pobytu, které mohou mít jiné zákony o ochraně dat.',
    },

    changes: {
      title: 'Změny těchto zásad ochrany osobních údajů',
      description: 'Tyto zásady ochrany osobních údajů můžeme čas od času aktualizovat. O všech změnách vás budeme informovat zveřejněním nových zásad ochrany osobních údajů na této stránce a aktualizací data "Naposledy aktualizováno". Významné změny budou sděleny e-mailem nebo viditelným oznámením na našich webových stránkách.',
    },

    contact: {
      title: 'Kontaktujte nás',
      description: 'Pokud máte jakékoli dotazy, obavy nebo žádosti týkající se těchto zásad ochrany osobních údajů nebo našich postupů týkajících se dat, kontaktujte nás prosím:',
      email: 'E-mail:',
      company: 'Společnost:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Podmínky služby',
    lastUpdated: 'Poslední aktualizace',
    back: 'Zpět',
    viewPrivacyPolicy: 'Zobrazit zásady ochrany osobních údajů',
    acknowledgment: 'Používáním Zodiac Chess potvrzujete, že jste si přečetli, porozuměli a souhlasíte s těmito Podmínkami služby.',
    acceptance: {
      title: '1. Přijetí podmínek',
      p1: 'Přístupem k Zodiac Chess ("Služba") a jejím používáním přijímáte a souhlasíte s těmito Podmínkami služby. Pokud s těmito podmínkami nesouhlasíte, prosím nepoužívejte Službu.',
      p2: 'Vyhrazujeme si právo tyto podmínky kdykoli změnit. Pokračující používání Služby po změnách představuje přijetí upravených podmínek.',
    },
    description: {
      title: '2. Popis služby',
      p1: 'Zodiac Chess je online strategická desková hra s unikátními zvířecími figurkami se speciálními schopnostmi. Služba zahrnuje:',
      feature1: 'Hraní pro jednoho hráče proti AI soupeřům',
      feature2: 'Multiplayer matchmaking a soutěžní hru',
      feature3: 'Interaktivní tutoriály a vzdělávací zdroje',
      feature4: 'Vytvoření účtu a sledování postupu',
      feature5: 'Volitelné prémiové předplatné',
      feature6: 'Kosmetické možnosti přizpůsobení',
    },
    accounts: {
      title: '3. Uživatelské účty',
      eligibility: {
        title: '3.1 Způsobilost',
        p1: 'Pro vytvoření účtu musíte být starší 13 let. Uživatelé mladší 13 let mohou používat režim hosta pod dohledem rodičů, ale nemohou vytvářet účty.',
      },
      responsibilities: {
        title: '3.2 Zabezpečení účtu',
        p1: 'Jste odpovědní za:',
        item1: 'Zachování důvěrnosti vašeho hesla',
        item2: 'Všechny aktivity, které probíhají pod vaším účtem',
        item3: 'Okamžité oznámení jakéhokoli neoprávněného použití',
        p2: 'Nejsme odpovědní za jakoukoli ztrátu nebo škodu vyplývající z neoprávněného přístupu k účtu.',
      },
      prohibited: {
        title: '3.3 Zakázané aktivity',
        p1: 'NESMÍTE:',
        item1: 'Sdílet svůj účet s ostatními',
        item2: 'Používat více účtů k manipulaci s žebříčky',
        item3: 'Používat boty, skripty nebo automatizované nástroje ke hraní her',
        item4: 'Obtěžovat, zneužívat nebo vyhrožovat ostatním hráčům',
        item5: 'Využívat chyby nebo závady k získání neférové výhody',
        item6: 'Provádět reverzní inženýrství nebo se pokoušet o přístup k našemu zdrojovému kódu',
        p2: 'Porušení těchto pravidel může vést k pozastavení účtu nebo trvalému zákazu.',
      },
    },
    premium: {
      title: '4. Prémiové předplatné',
      billing: {
        title: '4.1 Fakturace',
        p1: 'Prémiové předplatné je zpracováváno přes Stripe. Zakoupením prémiového předplatného nás opravňujete účtovat vaši platební metodu opakovaně, dokud nezrušíte.',
        p2: 'Poplatky za předplatné jsou:',
        item1: 'Měsíční plán: Účtováno měsíčně v den výročí vašeho nákupu',
        item2: 'Roční plán: Účtováno ročně v den výročí vašeho nákupu',
        p3: 'Ceny se mohou změnit s 30denním upozorněním aktivním předplatitelům.',
      },
      cancellation: {
        title: '4.2 Zrušení',
        p1: 'Své předplatné můžete kdykoli zrušit prostřednictvím nastavení účtu nebo kontaktováním podpory. Zrušení nabývá účinnosti na konci aktuálního fakturačního období.',
        p2: 'Prémiové funkce si zachováte až do konce placeného období, i po zrušení.',
      },
      refunds: {
        title: '4.3 Vrácení peněz',
        p1: 'Měsíční předplatné: Žádné vrácení peněz za částečné měsíce. Kdykoli zrušte pro zastavení budoucích poplatků.',
        p2: 'Roční předplatné: Plné vrácení peněz, pokud je požadováno do 7 dnů od nákupu. Po 7 dnech je vrácení peněz na našem uvážení.',
        p3: 'Kosmetické nákupy: Obecně nevratné. Kontaktujte podporu pro výjimečné okolnosti.',
      },
    },
    acceptable: {
      title: '5. Zásady přijatelného užívání',
      p1: 'Souhlasíte s používáním Zodiac Chess respektujícím a zákonným způsobem. Zakázané chování zahrnuje:',
      item1: 'Podvádění, hackování nebo zneužívání herních mechanismů',
      item2: 'Obtěžování, nenávistné projevy nebo diskriminační jazyk',
      item3: 'Spam, reklamu nebo nabídky',
      item4: 'Sdílení nevhodného obsahu (pokud je povolen chat nebo obsah vytvářený uživateli)',
      item5: 'Vydávání se za jiné uživatele nebo členy týmu',
      item6: 'Pokus o narušení nebo poškození Služby',
      p2: 'Vyhrazujeme si právo vyšetřovat porušení a přijmout vhodná opatření, včetně ukončení účtu a nahlášení úřadům, pokud je to nutné.',
    },
    intellectual: {
      title: '6. Práva duševního vlastnictví',
      ownership: {
        title: '6.1 Náš obsah',
        p1: 'Veškerý herní obsah, včetně, ale nejen herních mechanismů, uměleckých děl, animací, zvukových efektů, kódu a designu, je vlastnictvím Animal Chess Limited nebo našich poskytovatelů licence.',
        p2: 'Je vám udělena omezená, nevýhradní, nepřenosná licence k používání Služby pouze pro osobní zábavu.',
      },
      userContent: {
        title: '6.2 Uživatelský obsah',
        p1: 'Odesláním obsahu (jako jsou chatové zprávy, uživatelská jména nebo informace o profilu) nám udělujete celosvětovou, bezúplatnou licenci k používání, zobrazování a distribuci tohoto obsahu v souvislosti se Službou.',
        p2: 'Prohlašujete, že vlastníte nebo máte potřebná práva k jakémukoli obsahu, který odesíláte.',
      },
    },
    disclaimers: {
      title: '7. Vyloučení odpovědnosti a omezení odpovědnosti',
      p1: 'SLUŽBA JE POSKYTOVÁNA "TAK, JAK JE" BEZ JAKÝCHKOLI ZÁRUK, AŤ UŽ VÝSLOVNÝCH NEBO PŘEDPOKLÁDANÝCH.',
      p2: 'Nezaručujeme, že:',
      item1: 'Služba bude nepřerušená nebo bez chyb',
      item2: 'Vady budou opraveny',
      item3: 'Služba je bez virů nebo škodlivých komponent',
      item4: 'Výsledky používání Služby splní vaše očekávání',
      p3: 'V MAXIMÁLNÍM ROZSAHU POVOLENÉM ZÁKONEM NEJSME ODPOVĚDNÍ ZA:',
      item5: 'Jakékoli nepřímé, náhodné nebo následné škody',
      item6: 'Ztrátu zisku, dat nebo dobré pověsti',
      item7: 'Přerušení služby nebo ztrátu dat',
      item8: 'Škody přesahující částku, kterou jste nám zaplatili za posledních 12 měsíců',
    },
    privacy: {
      title: '8. Soukromí',
      p1: 'Vaše používání Služby se také řídí našimi Zásadami ochrany osobních údajů, které vysvětlují, jak shromažďujeme, používáme a chráníme vaše osobní údaje.',
      p2: 'Používáním Služby souhlasíte s našimi postupy zpracování údajů, jak jsou popsány v Zásadách ochrany osobních údajů.',
    },
    changes: {
      title: '9. Změny podmínek',
      p1: 'Vyhrazujeme si právo tyto Podmínky služby kdykoli změnit. O podstatných změnách budeme uživatele informovat prostřednictvím:',
      item1: 'E-mailového oznámení registrovaným uživatelům',
      item2: 'Výrazného upozornění na webových stránkách',
      item3: 'Aktualizovaného data "Poslední aktualizace" v horní části této stránky',
      p2: 'Vaše pokračující používání Služby po změnách představuje přijetí upravených podmínek.',
    },
    governing: {
      title: '10. Rozhodné právo',
      p1: 'Tyto Podmínky služby se řídí zákony Nového Zélandu, bez ohledu na principy kolize právních norem.',
      p2: 'Jakékoli spory vyplývající z těchto podmínek nebo vašeho používání Služby budou řešeny u soudů Nového Zélandu.',
    },
    contact: {
      title: '11. Kontaktní informace',
      p1: 'Pro dotazy, obavy nebo podporu týkající se těchto Podmínek služby:',
      email: 'E-mail:',
      company: 'Společnost:',
      address: 'Adresa:',
    },
    severability: {
      title: '12. Oddělitelnost',
      p1: 'Pokud je jakékoli ustanovení těchto podmínek shledáno nevymahatelným nebo neplatným, bude toto ustanovení omezeno nebo odstraněno v minimálním nezbytném rozsahu a zbývající ustanovení zůstanou v plné platnosti a účinnosti.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Zásady používání cookies',
    lastUpdated: 'Poslední aktualizace',
    browserInstructions: {
      chrome: 'Nastavení → Soukromí a zabezpečení → Soubory cookie',
      firefox: 'Nastavení → Soukromí a zabezpečení → Cookies a data stránek',
      safari: 'Předvolby → Soukromí → Cookies a data webových stránek',
      edge: 'Nastavení → Soukromí, vyhledávání a služby → Soubory cookie',
    },
    cookieTable: {
      name: 'Název cookie',
      purpose: 'Účel',
      duration: 'Doba trvání',
      type: 'Typ',
    },
    relatedPolicies: {
      title: 'Související zásady',
      description: 'Pro více informací o tom, jak nakládáme s vašimi údaji, prosím navštivte:',
      privacy: 'Zásady ochrany osobních údajů',
      terms: 'Podmínky služby',
    },

    introduction: {
      title: 'Úvod',
      p1: 'Tyto zásady používání cookies vysvětlují, jak Zodiac Chess ("my," "náš") používá cookies a podobné technologie při návštěvě našich webových stránek.',
      p2: 'Používáním našich webových stránek souhlasíte s naším používáním cookies v souladu s těmito zásadami. Pokud nesouhlasíte, prosím zakažte cookies v nastavení prohlížeče nebo naše webové stránky nepoužívejte.',
    },
    what: {
      title: 'Co jsou cookies?',
      p1: 'Cookies jsou malé textové soubory, které jsou umístěny na vašem zařízení (počítač, smartphone, tablet) při návštěvě webové stránky. Jsou široce používány k zajištění efektivního fungování webových stránek a poskytování informací vlastníkům webových stránek.',
      p2: 'Cookies slouží různým účelům, včetně zapamatování vašich preferencí, analýzy používání stránek a umožnění určitých funkcí.',
    },
    types: {
      title: 'Typy cookies, které používáme',
      necessary: {
        title: '1. Nezbytné cookies',
        description: 'Tyto cookies jsou nezbytné pro správné fungování webových stránek. Bez těchto cookies nelze poskytovat služby, které jste požadovali.',
        examples: 'Příklady:',
        item1: 'Autentizační cookies - udržují vás přihlášeného k vašemu účtu',
        item2: 'Bezpečnostní cookies - chrání před podvodnými aktivitami',
        item3: 'Relační cookies - udržují stav vaší hry během relace',
        item4: 'Preference souhlasu s cookies - pamatují si vaše volby týkající se cookies',
      },
      analytics: {
        title: '2. Analytické cookies',
        description: 'Tyto cookies nám pomáhají pochopit, jak návštěvníci interagují s našimi webovými stránkami, shromažďováním anonymních informací o návštěvách stránek, stráveném čase a použitých funkcích.',
        provider: 'Poskytovatel: Firebase Analytics (Google)',
        purpose: 'Účel:',
        item1: 'Měření návštěvnosti webových stránek a zapojení uživatelů',
        item2: 'Identifikace oblíbených funkcí a stránek',
        item3: 'Porozumění demografii uživatelů (věkové rozmezí, obecná poloha)',
        item4: 'Zlepšení výkonu webových stránek a uživatelského zážitku',
      },
      advertising: {
        title: '3. Reklamní cookies',
        description: 'Tyto cookies se používají k zobrazování reklam, které jsou pro vás relevantní. Také omezují počet zobrazení reklamy a pomáhají měřit účinnost reklamních kampaní.',
        provider: 'Poskytovatel: Google AdSense',
        purpose: 'Účel:',
        item1: 'Zobrazování personalizovaných reklam na základě vašich zájmů',
        item2: 'Měření výkonu reklam a zapojení',
        item3: 'Zabránění příliš častému zobrazování stejné reklamy',
        note: 'Poznámka: Prémiový předplatitelé nikdy nevidí reklamy, bez ohledu na nastavení cookies.',
      },
    },
    firstThird: {
      title: 'Cookies první strany vs. cookies třetích stran',
      firstParty: {
        title: 'Cookies první strany',
        description: 'Jedná se o cookies nastavené přímo Zodiac Chess. Používáme je pro základní funkčnost stránek, autentizaci a zapamatování vašich preferencí.',
      },
      thirdParty: {
        title: 'Cookies třetích stran',
        description: 'Jedná se o cookies nastavené externími službami, které používáme, jako jsou Google Analytics a Google AdSense. Cookies třetích stran podléhají zásadám ochrany osobních údajů těchto poskytovatelů.',
      },
    },
    specific: {
      title: 'Konkrétní cookies, které používáme',
      tableHeader: 'Níže je podrobný seznam cookies používaných na našich webových stránkách:',
    },
    control: {
      title: 'Jak ovládat cookies',
      consent: {
        title: '1. Banner souhlasu s cookies',
        description: 'Při první návštěvě našich webových stránek uvidíte banner souhlasu s cookies. Můžete:',
        item1: 'Přijmout vše - povolit všechny cookies (nezbytné, analytické a reklamní)',
        item2: 'Odmítnout volitelné - povolit pouze nezbytné cookies (žádné analytické ani reklamní)',
        item3: 'Přizpůsobit - vybrat přesně, které typy cookies chcete povolit',
      },
      browser: {
        title: '2. Nastavení prohlížeče',
        description: 'Většina webových prohlížečů vám umožňuje ovládat cookies prostřednictvím jejich nastavení. Můžete:',
        item1: 'Blokovat všechny cookies',
        item2: 'Přijímat pouze cookies první strany',
        item3: 'Mazat cookies po každé relaci prohlížení',
        item4: 'Zobrazit a mazat jednotlivé cookies',
        links: 'Zde jsou odkazy na správu cookies pro populární prohlížeče:',
      },
      optOut: {
        title: '3. Nástroje pro odhlášení',
        description: 'Konkrétně pro reklamní cookies se můžete odhlásit z personalizovaných reklam:',
        googleLink: 'Nastavení reklam Google',
        googleDesc: ' - Spravujte personalizované reklamy Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Odhlaste se z reklam založených na zájmech',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Nástroj pro odhlášení specifický pro EU',
      },
    },
    impact: {
      title: 'Dopad zakázání cookies',
      p1: 'Pokud cookies zakážete nebo odmítnete, mějte prosím na paměti, že:',
      item1: 'Některé části webových stránek nemusí správně fungovat',
      item2: 'Možná budete muset při každé návštěvě znovu zadat své preference',
      item3: 'Můžete být odhlášeni ze svého účtu',
      item4: 'Nezbytné cookies jsou vyžadovány pro fungování stránek - jejich zakázání vám zabrání v používání základních funkcí',
    },
    updates: {
      title: 'Aktualizace těchto zásad používání cookies',
      p1: 'Tyto zásady používání cookies můžeme čas od času aktualizovat, abychom odráželi změny v našich postupech nebo z právních, regulačních či provozních důvodů.',
      p2: 'O významných změnách vás budeme informovat aktualizací data "Poslední aktualizace" v horní části této stránky. Prosím pravidelně tyto zásady kontrolujte.',
    },
    contact: {
      title: 'Kontaktujte nás',
      p1: 'Máte-li dotazy ohledně našeho používání cookies nebo těchto zásad, prosím kontaktujte nás:',
      email: 'E-mail:',
      company: 'Společnost:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Tučňák',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'Medvěd',
    Crane: 'Jeřáb',
    Frog: 'Žába',
    Fungi: 'Houba',
    Goat: 'Koza',
    Monkey: 'Opice',
    Octopus: 'Chobotnice',
    Penguin: 'Tučňák',
    Rhino: 'Nosorožec',
    Snake: 'Had',
    Tree: 'Strom',
    Virus: 'Virus',
    Wolf: 'Vlk',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
